import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Toaster from 'src/components/Toaster';

import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';

import { icons } from './assets/icons';
import * as serviceWorker from './serviceWorker';
import store from './store';

React.icons = icons;

ReactDOM.render(
  <Provider store={store}>
    <Toaster />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
